// extracted by mini-css-extract-plugin
export default {"layout":"_16488e9416 _737fa106f2 _3b06e4d776","h_slide":"e9a58aa355","category":"cf6177ff17 _82a4d37095 b6be94c467"};